import { j as c } from "./jsx-runtime-3tyXYecC.mjs";
import { useMemo as E, useRef as H, useState as K, useImperativeHandle as L } from "react";
import { f as u } from "./index-LyFokDcn.mjs";
import { m as N } from "./tss-DN0acMKN.mjs";
import { M as z, d as $ } from "./constants-CnFYFetN.mjs";
import { L as V } from "./layout-box-DFBM-kSI.mjs";
import { S as _ } from "./status-message-BMoS1d1Y.mjs";
import { _ as j } from "./composeRefs-YONvD-rx.mjs";
import { m as O } from "./index-BGgjYpYz.mjs";
import { g as B } from "./get-aria-describedby-G1wcWKF2.mjs";
import { D as U } from "./default-error-messages.constants-BvAz67KV.mjs";
import { u as q } from "./use-rhf-wrapper-controller-DGFm3TD5.mjs";
import { t as G } from "./toggle-rhf-rules-Z1TdwfO9.mjs";
import { a as W } from "./add-rhf-default-error-message-C9MkLfg3.mjs";
import { e as J } from "./extract-rhf-validation-rule-value-DyB3XAHu.mjs";
import { c as P } from "./combine-function-calls-C5qD-ZYI.mjs";
const Q = N()((g, f, l) => {
  const { disabled: m, large: e } = f, { constructs: r, palette: o, mode: a, mixins: t } = g;
  let i = u.ifFeature("encore", r.surface.primary.strong, o.primary.main), s = u.ifFeature("encore", r.surface.neutral.medium, o.gray[500]);
  return m && (i = o.gray[300], s = o.gray[300]), a === z.Dye && (i = $.main, s = $.lighter), {
    toggle: {
      // The background of the RoundedToggle
      backgroundColor: s,
      boxSizing: "border-box",
      display: "inline-flex",
      outline: a === z.Dye ? `1px solid ${$.main}` : void 0,
      position: "relative",
      ...u.ifFeature(
        "encore",
        {
          border: "none",
          borderRadius: "25px",
          boxShadow: t.boxShadow("100", r.surface.neutral.xxStrong),
          height: e ? "32px" : "20px",
          width: e ? "56px" : "36px"
        },
        {
          border: "none",
          borderRadius: "25px",
          height: e ? "20px" : "18px",
          width: e ? "36px" : "32px"
        }
      ),
      [`&:has( .${l.input}:checked)`]: u.ifFeature(
        // Adds checked styles to the RoundedToggle when the input is checked
        "encore",
        {
          backgroundColor: i,
          boxShadow: `inset 2px 2px 0 1px ${t.alpha(r.surface.neutral.xxStrong, 0.1)}`,
          [`& .${l.circleKnob}:before`]: {
            // Updates the circle switch's position inside of the RoundedToggle
            backgroundImage: t.inlineSvg(
              '<svg viewBox="0 0 64 512" xmlns="http://www.w3.org/2000/svg" fill="#000"><path xmlns="http://www.w3.org/2000/svg" d="M32 0C49.7 0 64 14.3 64 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32C0 14.3 14.3 0 32 0z"></path></svg>',
              { fill: o.primary.main }
            ),
            backgroundSize: e ? "2px 12px" : "2px 8px",
            left: e ? "28px" : "18px"
          }
        },
        {
          backgroundColor: i,
          boxShadow: "0 1px 0 0 rgba(0, 0, 0, 0.05)",
          [`& .${l.circleKnob}:before`]: {
            // Updates the circle switch's position inside of the RoundedToggle
            left: e ? "17px" : "16px"
          }
        }
      ),
      [`&:has(.${l.input}:focus)`]: u.ifFeature("encore", {
        boxShadow: `0 0 0 2px ${r.surface.primary.medium}, 0 0 0 4px ${r.surface.primary.weak}, inset 2px 2px 0 1px ${t.alpha(o.grey[900], 0.1)}`
      })
    },
    circleKnob: u.ifFeature(
      // The circle switch inside of the RoundedToggle
      "encore",
      {
        "&:before": {
          backgroundColor: o.common.white,
          borderRadius: "25px",
          content: '""',
          height: e ? "24px" : "16px",
          width: e ? "24px" : "16px",
          left: e ? "4px" : "2px",
          opacity: 1,
          position: "absolute",
          top: e ? "4px" : "2px",
          transition: "left 200ms cubic-bezier(0.25, 0.1, 0.25, 1)",
          boxShadow: `1px 1px 0 0 ${t.alpha(o.common.black, 0.1)}`,
          backgroundImage: t.inlineSvg(
            '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="#000"><path xmlns="http://www.w3.org/2000/svg" d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"></path></svg>',
            { fill: o.gray[400] }
          ),
          backgroundSize: e ? "12px" : "8px",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center"
        }
      },
      {
        "&:before": {
          backgroundColor: o.common.white,
          borderRadius: "25px",
          content: '""',
          height: e ? "18px" : "16px",
          width: e ? "18px" : "15px",
          left: "1px",
          opacity: 1,
          position: "absolute",
          top: "1px",
          transition: "left 200ms cubic-bezier(0.25, 0.1, 0.25, 1)"
        }
      }
    ),
    input: {
      // The actual input checkbox that is hidden inside of the RoundedToggle
      border: 0,
      cursor: "pointer",
      height: "100%",
      left: 0,
      margin: 0,
      opacity: 1e-4,
      // Fixes focus outline for focus rings created by ScreenReaders
      padding: 0,
      position: "absolute",
      top: 0,
      width: "100%",
      zIndex: 1,
      "&:disabled": {
        cursor: "default"
      }
    }
  };
}), X = (g) => {
  const {
    apiRef: f,
    ariaLabel: l,
    ariaDescribedby: m,
    biId: e,
    containerRef: r,
    errorMessage: o,
    id: a,
    inputRef: t,
    isChecked: i = !1,
    isControlled: s = !1,
    isDisabled: k = !1,
    isRequired: y = !1,
    name: R,
    onBlur: S,
    onChange: p,
    size: C = "regular",
    status: n,
    warningMessage: x
  } = g, v = E(() => O(), []), M = R || "fab-roundedToggle", b = a || `fab-rounded-Toggle--${v}`, { classes: h } = Q({ disabled: k, large: C === "large" }), d = H(null), [F, I] = K(i);
  L(
    f,
    () => ({
      focus: () => {
        var w;
        (w = d.current) == null || w.focus();
      }
    }),
    [d]
  );
  const D = `${b}-status-message`, T = n === "error" ? o : x, A = B(n === "error" && o || n === "warning" && x ? D : "", m);
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsxs(
      "span",
      {
        className: h.toggle,
        "data-bi-id": e,
        "data-fabric-component": "RoundedToggle",
        ref: r,
        children: [
          /* @__PURE__ */ c.jsx(
            "input",
            {
              "aria-checked": s ? i : F,
              "aria-describedby": A,
              "aria-invalid": n === "error",
              "aria-label": l,
              checked: s ? i : F,
              className: h.input,
              defaultChecked: s ? void 0 : F,
              disabled: k,
              id: b,
              name: M,
              onBlur: S,
              onChange: (w) => {
                s || I(w.target.checked), p == null || p(w);
              },
              ref: j(d, t),
              required: y,
              role: "switch",
              type: "checkbox"
            }
          ),
          /* @__PURE__ */ c.jsx("span", { className: h.circleKnob })
        ]
      }
    ),
    (n === "error" && o || n === "warning" && x) && /* @__PURE__ */ c.jsx(V, { marginTop: 0.5, children: /* @__PURE__ */ c.jsx(_, { id: D, message: T, showIcon: !0, status: n }) })
  ] });
};
function me({
  apiRef: g,
  ariaDescribedby: f,
  control: l,
  defaultValue: m = !1,
  disabled: e,
  errorMessageId: r,
  status: o,
  required: a = !1,
  name: t,
  onBlur: i,
  onChange: s,
  shouldUnregister: k,
  validate: y,
  ...R
}) {
  var b;
  const { field: S, fieldState: p } = q({
    control: l,
    defaultValue: m,
    name: t,
    // This is a workaround for `disabled` because it is not available in `useController` yet (not available until v7.48.0).
    rules: G(
      {
        required: typeof a == "string" ? a : W(a, U.requiredToggle),
        validate: y
      },
      e
    ),
    shouldUnregister: k
  }), { onBlur: C, onChange: n, ref: x, value: v } = S, M = (h) => {
    const d = h.target.checked;
    n(d), typeof s == "function" && s(d);
  };
  return /* @__PURE__ */ c.jsx(
    X,
    {
      ...R,
      apiRef: j(x, g),
      ariaDescribedby: B(p.error ? r : void 0, f),
      errorMessage: r || (b = p.error) == null ? void 0 : b.message,
      isChecked: v,
      isDisabled: e,
      isRequired: typeof a == "string" ? !!a : J(a),
      name: t,
      onBlur: P(C, i),
      onChange: M,
      status: p.error ? "error" : o
    }
  );
}
export {
  me as R,
  X as a
};
//# sourceMappingURL=rounded-toggle-rhf-D2W1fUkg.mjs.map
